import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import theme from '../../styles/theme';
import { Spinner } from '../spinner/spinner';
const Overlay = styled.div({
    background: 'rgba(255,255,255,0.5)',
    textAlign: 'center',
    position: 'relative',
    height: 'calc(100vh - 250px)',
    width: '100%',
});
const SpinnerContainer = styled.div({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
});
const LoadingOverlay = () => {
    return (_jsx(Overlay, { children: _jsx(SpinnerContainer, { children: _jsx(Spinner, { size: "40px", color: theme.colors.grey30 }) }) }));
};
export default LoadingOverlay;
//# sourceMappingURL=loading_overlay.js.map